var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '@utils/apiClient';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
export const serviceHistoryService = {
    getAll() {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.get('/service-history');
        });
    },
    getByMachineId(machineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.get(`/machines/${machineId}/service-history`);
        });
    },
    getById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.get(`/service-history/${id}`);
        });
    },
    create(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.post('/service-history', data);
        });
    },
    update(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.put(`/service-history/${id}`, data);
        });
    },
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.delete(`/service-history/${id}`);
        });
    },
    exportToExcel(machineId) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = localStorage.getItem('token');
            const url = machineId
                ? `${API_BASE_URL}/service-history/export?machineId=${machineId}`
                : `${API_BASE_URL}/service-history/export`;
            const response = yield fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.ok) {
                throw new Error('Failed to export service history');
            }
            return response.blob();
        });
    },
};
